import { getRouteApi } from '@tanstack/react-router';

import { OAuthInstallCallback } from '~/components/connections/OAuthInstallCallback';

const routeApi = getRouteApi('/oauth/slack/callback');

export function SlackOAuthCallbackPage() {
  const { connectionId, topicId, error, message } = routeApi.useSearch();

  return (
    <OAuthInstallCallback
      provider="Slack"
      connectionId={connectionId}
      topicId={topicId}
      errorCode={error}
      errorMessage={message}
      errors={{
        access_denied: {
          title: 'Slack installation cancelled',
          details: 'You declined to install the DeadDrop app in your Slack workspace.',
        },
        token_exchange_failed: {
          title: 'Slack connection failed',
          details: message || 'Failed to exchange OAuth code for access token.',
        },
      }}
    />
  );
}
